/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  BatchUploadRequestSubCategoryDto,
  BatchUploadReviewPayload,
  CategorySubCategoryDto,
  CreateSubcategoryRequest,
  CsvReviewResponseSubCategoryDto,
  GetAllPagedByOrganisation2Params,
  GetGroupedSubcategoryForOrganisationParams,
  GetSubcategoryForOrganisationParams,
  InfiniteScrollListSubCategoryDtoObject,
  PullAccountingAttributesRequest,
  SubCategoryBulkUpdateRequest,
  SubCategoryDto,
  UpdateSubcategoryRequest,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiSubCategoryController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-sub-category-controller
   * @name GetSubcategoryById
   * @summary Return sub-category by sub-category id
   * @request GET:/api/v1/sub-category/{subCategoryId}
   */
  getSubcategoryById = (subCategoryId: string, params: RequestParams = {}) =>
    this.http.request<SubCategoryDto, any>({
      path: `/v1/sub-category/${subCategoryId}`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getSubcategoryByIdPath = '/v1/sub-category/${subCategoryId}'
  static getSubcategoryByIdMethod = 'GET'
  /**
   * No description
   *
   * @tags api-sub-category-controller
   * @name UpdateSubCategory
   * @request PUT:/api/v1/sub-category/{subCategoryId}
   */
  updateSubCategory = (
    subCategoryId: string,
    data: UpdateSubcategoryRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/v1/sub-category/${subCategoryId}`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static updateSubCategoryPath = '/v1/sub-category/${subCategoryId}'
  static updateSubCategoryMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-sub-category-controller
   * @name DeleteSubCategory
   * @request DELETE:/api/v1/sub-category/{subCategoryId}
   */
  deleteSubCategory = (subCategoryId: string, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/sub-category/${subCategoryId}`,
      method: 'DELETE',
      ...params,
    })

  static deleteSubCategoryPath = '/v1/sub-category/${subCategoryId}'
  static deleteSubCategoryMethod = 'DELETE'
  /**
   * No description
   *
   * @tags api-sub-category-controller
   * @name CreateSubCategory
   * @request POST:/api/v1/sub-category
   */
  createSubCategory = (data: CreateSubcategoryRequest, params: RequestParams = {}) =>
    this.http.request<SubCategoryDto, any>({
      path: `/v1/sub-category`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static createSubCategoryPath = '/v1/sub-category'
  static createSubCategoryMethod = 'POST'
  /**
   * No description
   *
   * @tags api-sub-category-controller
   * @name PullAttributesFromSourceOrganisation1
   * @request POST:/api/v1/sub-category/pull-from-other-org
   */
  pullAttributesFromSourceOrganisation = (
    data: PullAccountingAttributesRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/v1/sub-category/pull-from-other-org`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static pullAttributesFromSourceOrganisationPath = '/v1/sub-category/pull-from-other-org'
  static pullAttributesFromSourceOrganisationMethod = 'POST'
  /**
   * No description
   *
   * @tags api-sub-category-controller
   * @name BulkUpdateSubCategories
   * @request POST:/api/v1/sub-category/bulk-update
   */
  bulkUpdateSubCategories = (data: SubCategoryBulkUpdateRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/sub-category/bulk-update`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static bulkUpdateSubCategoriesPath = '/v1/sub-category/bulk-update'
  static bulkUpdateSubCategoriesMethod = 'POST'
  /**
   * No description
   *
   * @tags api-sub-category-controller
   * @name BatchUpload
   * @request POST:/api/v1/sub-category/batch-upload
   */
  batchUpload = (data: BatchUploadRequestSubCategoryDto, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/sub-category/batch-upload`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static batchUploadPath = '/v1/sub-category/batch-upload'
  static batchUploadMethod = 'POST'
  /**
   * No description
   *
   * @tags api-sub-category-controller
   * @name BatchUploadReview
   * @request POST:/api/v1/sub-category/batch-upload/review
   */
  batchUploadReview = (data: BatchUploadReviewPayload, params: RequestParams = {}) =>
    this.http.request<CsvReviewResponseSubCategoryDto, any>({
      path: `/v1/sub-category/batch-upload/review`,
      method: 'POST',
      body: data,
      type: ContentType.FormData,
      format: 'json',
      ...params,
    })

  static batchUploadReviewPath = '/v1/sub-category/batch-upload/review'
  static batchUploadReviewMethod = 'POST'
  /**
   * No description
   *
   * @tags api-sub-category-controller
   * @name GetSubcategoryByIds
   * @summary Receive a list of sub-category ids separate by comma and returns a list of sub-categories
   * @request GET:/api/v1/sub-category/{subCategoryIds}
   */
  getSubcategoryByIds = (subCategoryIds: string[], params: RequestParams = {}) =>
    this.http.request<SubCategoryDto[], any>({
      path: `/v1/sub-category/${subCategoryIds}`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getSubcategoryByIdsPath = '/v1/sub-category/${subCategoryIds}'
  static getSubcategoryByIdsMethod = 'GET'
  /**
   * No description
   *
   * @tags api-sub-category-controller
   * @name GetAllPagedByOrganisation2
   * @request GET:/api/v1/sub-category/paged
   */
  getAllPagedByOrganisation = (
    query: GetAllPagedByOrganisation2Params,
    params: RequestParams = {},
  ) =>
    this.http.request<InfiniteScrollListSubCategoryDtoObject, any>({
      path: `/v1/sub-category/paged`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getAllPagedByOrganisationPath = '/v1/sub-category/paged'
  static getAllPagedByOrganisationMethod = 'GET'
  /**
   * No description
   *
   * @tags api-sub-category-controller
   * @name GetSubcategoryForOrganisation
   * @request GET:/api/v1/sub-category/list
   */
  getSubcategoryForOrganisation = (
    query: GetSubcategoryForOrganisationParams,
    params: RequestParams = {},
  ) =>
    this.http.request<SubCategoryDto[], any>({
      path: `/v1/sub-category/list`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getSubcategoryForOrganisationPath = '/v1/sub-category/list'
  static getSubcategoryForOrganisationMethod = 'GET'
  /**
   * No description
   *
   * @tags api-sub-category-controller
   * @name GetGroupedSubcategoryForOrganisation
   * @request GET:/api/v1/sub-category/list/grouped
   * @deprecated
   */
  getGroupedSubcategoryForOrganisation = (
    query: GetGroupedSubcategoryForOrganisationParams,
    params: RequestParams = {},
  ) =>
    this.http.request<CategorySubCategoryDto[], any>({
      path: `/v1/sub-category/list/grouped`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getGroupedSubcategoryForOrganisationPath = '/v1/sub-category/list/grouped'
  static getGroupedSubcategoryForOrganisationMethod = 'GET'
}
